// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"0b41a122","90":"749d7db2","125":"cd5db477","144":"db2c54d7","175":"6577c63f","279":"7f45015a","520":"4cd8a7cd","560":"b8b0491e","561":"045e3be2","608":"55566746","629":"e2536137","655":"e05ab4ea","790":"1ed9bd7a","815":"b73f9cc7","825":"d055f501","989":"9484970a"}[chunkId] + ".chunk.js";
};